<template>
  <div class="laryerBody">
    <!-- <div class=""></div> -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>图层管理</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="isShowuploadPop = true"
          >上传图层</el-button
        >
      </div>
      <div class="cordBody">
        <el-table :data="tableData" style="width: 100%" height="700">
          <el-table-column prop="name" label="图层名称"></el-table-column>
          <el-table-column prop="type" label="图层类型"></el-table-column>
          <el-table-column prop="geom" label="图层数据">
            <template slot-scope="scope">
              <div class="mytextBox">
                {{ scope.row.geom }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
          <el-table-column prop="uploadUser" label="上传用户"></el-table-column>
          <el-table-column prop="uploadUser" label="是否显示">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isSHow"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="uploadUser" width="300" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="openMapBox(scope.row)"
                >查看</el-button
              >
              <el-button size="mini" type="primary">导出图层属性</el-button>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 15px"
          background
          layout="prev, pager, next"
          :total="1000"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog title="上传图层" :visible.sync="isShowuploadPop" width="30%">
      <el-form :model="form">
        <!-- <el-form-item label="图层名称：" :label-width="formLabelWidth">
          <el-input v-model="form.layerName" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="文件类型：" :label-width="formLabelWidth">
          <el-select v-model="form.layType" placeholder="请选择">
            <el-option
              v-for="item in layerTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图层描述：" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.layerDes"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="图层文件：" :label-width="formLabelWidth">
          <el-upload
            ref="upload"
            action="111111"
            :limit="1"
            :file-list="fileList"
            accept="shp"
            :http-request="fileChange"
            :auto-upload="true"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上传文件</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowuploadPop = false">取 消</el-button>
        <el-button type="primary" @click="isShowuploadPop = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
    :show-close="false"
      :title="chooseData.name + '预览效果'"
      :visible.sync="isOpenMapPop"
      width="50%"
    >
      <div class="newMapBox" id="newMapBox"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMpa">取 消</el-button>
        <el-button type="primary" @click="closeMpa"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as shapefile from "shapefile";
import WKT from "terraformer-wkt-parser"
import { MapCreate, legendColor } from "../map/mapImport";
export default {
  data() {
    return {
      map: null,
      isOpenMapPop: false,
      formLabelWidth: "120px",
      layerTypeList: [
        {
          value: "cad",
          label: "cad文件",
        },
        {
          value: "shp",
          label: "shp文件",
        },
      ],
      form: {
        layerName: "",
        layType: "cad",
        layerDes: "",
      },
      isShowuploadPop: false,
      tableData: [],
      fileList: [],
      chooseData: {
        name: 1,
      },
    };
  },
  created() {
    this.getCadData();
  },
  methods: {
    openMapBox(e) {
      this.isOpenMapPop = true;
      this.chooseData = e;
      setTimeout(() => {
        this.showPopMap();
      }, 500);
    },
    closeMpa(){
      this.isOpenMapPop = false
      this.map.map.remove()
    },
    showPopMap() {
      this.map = new MapCreate();
      this.map.init("newMapBox");
      console.log();
      let newjson =  WKT.parse(this.chooseData.geom );
      // let newjson =  this.wktToGeoJSON(this.chooseData.geom)
      console.log(newjson);
      
       let shpData= L.geoJSON(newjson, {
          style: {
            color: "blue",
            weight: 2,
            fillColor: "lightblue",
            fillOpacity: 0.3
          }
        }).addTo(this.map.map);
        this.map.map.flyToBounds(shpData.getBounds());

    },
    getCadData() {
      let formData = new FormData();

      formData.append("para", '{"name":""}');
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: "https://moodsci.com/data/shpdata/getCadDay",
        data: formData,
      }).then((res) => {
        console.log(res.data.datas);
        res.data.datas.map((item) => {
          const pattern = /[A-Z]+\s*(?=\()/g;
          const types = item.geom.match(pattern);
          console.log(types);

          return (item.type = types[0]);
        });
        this.tableData = res.data.datas;
      });
    },
    
    fileChange(e) {
      let formData = new FormData();
      formData.append("file", e.file);
      let url = "https://moodsci.com/data/shpdata/importCad";
      if ((this.layType = "cad")) {
        url = "https://moodsci.com/data/shpdata/importCad";
      } else {
        url = "https://moodsci.com/data/shpdata/getShpDay";
      }
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        url: url,
        data: formData,
      }).then((res) => {
        console.log(res);
        this.getCadData()
      });
    },
    wktToGeoJSON(wkt) {
    // 去除首尾空格
    wkt = wkt.trim();
    if (!wkt) return null;

    // 提取几何类型（如 "POINT"、"LINESTRING"）
    const typeMatch = wkt.match(/^(\w+)\s*/);
    if (!typeMatch) return null;
    const type = typeMatch[1].toUpperCase(); // 转为大写统一处理

    // 提取坐标部分（去除类型和外层括号）
    const coordStr = wkt.replace(/^(\w+)\s*\(\s*/, '').replace(/\s*\)$/, '').trim();
    if (!coordStr) return null;

    // 根据不同类型解析坐标
    let coordinates;
    switch (type) {
        case 'POINT':
            // 点：POINT (x y) → [x, y]
            coordinates = coordStr.split(/\s+/).map(Number);
            break;

        case 'LINESTRING':
            // 线：LINESTRING (x1 y1, x2 y2) → [[x1,y1], [x2,y2]]
            coordinates = coordStr.split(/,\s*/).map(pair => 
                pair.split(/\s+/).map(Number)
            );
            break;

        case 'POLYGON':
            // 面：POLYGON ((x1 y1, x2 y2, x1 y1)) → [[[x1,y1], [x2,y2], [x1,y1]]]
            coordinates = coordStr.split(/\),\s*\(/).map(ring => 
                ring.replace(/^[\(\s]+|[\)\s]+$/g, '').split(/,\s*/).map(pair => 
                    pair.split(/\s+/).map(Number)
                )
            );
            // 修复可能的括号残留（确保是三维数组）
            coordinates = [coordinates].flat(1);
            break;

        case 'MULTIPOINT':
            // 多点：MULTIPOINT ((x1 y1), (x2 y2)) → [[x1,y1], [x2,y2]]
            coordinates = coordStr.split(/,\s*/).map(point => 
                point.replace(/^[\(\s]+|[\)\s]+$/g, '').split(/\s+/).map(Number)
            );
            break;

        case 'MULTILINESTRING':
            // 多线：MULTILINESTRING ((x1 y1, x2 y2), (x3 y3, x4 y4)) → [[[x1,y1], [x2,y2]], [[x3,y3], [x4,y4]]]
            coordinates = coordStr.split(/\),\s*\(/).map(line => 
                line.replace(/^[\(\s]+|[\)\s]+$/g, '').split(/,\s*/).map(pair => 
                    pair.split(/\s+/).map(Number)
                )
            );
            break;

        case 'MULTIPOLYGON':
            // 多面：MULTIPOLYGON (((x1 y1, x2 y2)), ((x3 y3, x4 y4))) → [[[[x1,y1], [x2,y2]]], [[[x3,y3], [x4,y4]]]]
            coordinates = coordStr.split(/\)\),\s*\(\(/).map(polygon => 
                polygon.replace(/^[\(\s]+|[\)\s]+$/g, '').split(/\),\s*\(/).map(ring => 
                    ring.replace(/^[\(\s]+|[\)\s]+$/g, '').split(/,\s*/).map(pair => 
                        pair.split(/\s+/).map(Number)
                    )
                )
            );
            break;

        default:
            throw new Error(`不支持的 WKT 类型：${type}`);
    }

    // 构建 GeoJSON Feature
    return {
        type: "Feature",
        geometry: {
            type: type.charAt(0) + type.slice(1).toLowerCase(), // 首字母大写，其余小写（如 LINESTRING → LineString）
            coordinates: coordinates
        },
        properties: {}
    };
}

  },
};
</script>

<style>
.laryerBody {
  height: 100%;
  width: 100%;
  padding: 15px;
  background-color: rgb(244, 244, 244);
}
.box-card {
  height: 100%;
  width: 100%;
}
.cordBody {
}
.mytextBox {
  height: 100px;
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  font-size: 8px;
}
.newMapBox {
  height: 500px;
  width: 45vw;
}
</style>
